import React, { useEffect, useState } from 'react';
import { Button, Space, Table, Tag } from 'antd';
import { formatCurrency } from "utils/number"
import { formatDate } from "utils/date"
import { useWebsiteStattistic } from '.';
import { useNavigate, useSearchParams } from 'react-router';

const Orders = () => {
  const columns = [
    {
      title: 'Đơn hàng',

      render: (_, record) => {
        return (
          <>
            <Button type='text' onClick={e => navigate(`/order/${record.id}`)}>
              {record.id}
            </Button>
            <div>
              {formatDate(record.create_at)}
            </div>
            <div>

              {record.shipping_address?.full_name}
            </div>

          </>
        )
      },
    },
    {
      title: 'Thành tiền',
      render: (_, record) => {
        return (
          <>
            {formatCurrency(record.total_amount)}
          </>
        )
      },
    },



  ];

  const navigate = useNavigate();
  const { data, filter, setFilter } = useWebsiteStattistic();
  const [orders, setorders] = useState([])
  useEffect(() => {
    if (data.orders) {
      setorders(data.orders);
    } else {
      setorders([])
    }
  }, [data.orders])



  return (
    <Table columns={columns} dataSource={orders} />
  )
};
export default Orders;